$(document).ready(() => {

	$("form.validation").validationEngine({
		showPrompts: false,
		addFailureCssClassToField: "error",
		scroll: false,
		onFieldFailure: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").addClass("error");
				}
			}
		},
		onFieldSuccess: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").removeClass("error");
				}
			}
		},
	});
	$("form.validation [class*=validate]").on("change blur keyup", function () {
		$(this).validationEngine("validate");
	});

	$("body").on("click", "form.ajax button[type=submit]", function (e) {
		e.preventDefault();
		postFormAjax($(this).closest("form"));
		return false;
	});

	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});

	$('body').on('click','#header .search a',function(e){
		e.preventDefault();
		if(!$('#header .search').hasClass('open'))$('#header .search input').focus();
		$('#header .search').toggleClass('open');
	});

	$('body').on('click','#header .msw a',function(e){
		e.preventDefault();
		if(!$('#header .msw').hasClass('open'))$('#header .msw input').focus();
		$('#header .msw').toggleClass('open');
	});

	$('body').on('mouseenter','#header nav li:has(ul)',function(e){
		e.preventDefault();
		const el = $(this);
		el.addClass('open');
		if(el.data('timer')){
			clearTimeout(el.data('timer'));
			el.data('timer',false);
		}
		el.one('mouseleave',function(){
			const timer = setTimeout(function(){
				el.removeClass('open');
			},100);
			el.data('timer',timer);
		});
	});

	$('body').on('click','.mobile-menu nav li:has(ul) > a',function(e){
		e.preventDefault();
		const el = $(this).closest('li');
		el.toggleClass('open');
	});

	$('body').on('click','#header .open-mobile-menu',function(e){
		e.preventDefault();
		$('.mobile-menu').addClass('open');
	});
	$('body').on('click','.mobile-menu .header .ls button',function(e){
		e.preventDefault();
		$('.mobile-menu').removeClass('open');
	});

	if ($(".news-detail .slider,.project-detail .slider").length) {
		tns({
			container: ".news-detail .slider,.project-detail .slider",
			items: 1,
			gutter: 0,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			responsive: {
				630: {
					items: 3,
					gutter: 30,
				},
			},
		});
	}

	if ($(".h-partners").length) {
		const homePartners = tns({
			container: ".h-partners .slider",
			items: 1,
			gutter: 0,
			edgePadding: 100,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			controls:false,
			responsive: {
				550: {
					items: 6,
					controls:true,
					edgePadding: 0,
				},
			},
		});
	}

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	try {
		media.addEventListener('change', mobileSupport);
	} catch (e1) {
		media.addListener(mobileSupport);
	}

});
$.is_mobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.is_mobile = true;

		$('#header .lang').appendTo('.mobile-menu .header .rs');
		$('#header nav').appendTo('.mobile-menu .body');
		$('<div class="ommw"><button class="open-mobile-menu"></button></div>').prependTo('#header .inner');

		$('<div class="msw"/>').appendTo('#header .inner');
		$('.mobile-menu .search > *').appendTo('#header .inner .msw');

		$('.h-news .header .rs').appendTo('.h-news .container');

		$(".mobile-menu").swipe( {
      //Generic swipe handler for all directions
      swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
        if($.is_mobile){
          if(direction=="left"){
            $('.mobile-menu .header .ls button').trigger('click');
          }
        }
      }
    });

		/*if ($(".vacancies-page .images").length) {
			tns({
				container: ".vacancies-page .images",
				items: 1,
				gutter: 0,
				controlsText: ["", ""],
				nav: false,
				loop: false,
			});
		}*/

		$(document).trigger("mobile_on");
	} else {
		$.is_mobile = false;

		$('.mobile-menu nav').appendTo('#header .inner');
		$('.mobile-menu .header .rs .lang').appendTo('#header .inner');

		$('#header .ommw').remove();

		$('#header .msw > *').appendTo('#header .search');
		$('#header .msw').remove();

		$('.h-news .container .rs').appendTo('.h-news .header');

		$(".mobile-menu").swipe("destroy");
		$(document).trigger("mobile_off");
	}
};

function postFormAjax(form) {
	if (form.validationEngine("validate") && form.attr("request") != 1) {
		let url = form.attr("action");

		const disabled = [];

		form.find(":disabled").each(function () {
			disabled.push(this);
			$(this).prop("disabled", false).removeProp("disabled");
		});
		let data = form.serialize();

		$.each(disabled, function () {
			$(this).prop("disabled", true);
		});

		$.ajax({
			url: url,
			type: "POST",
			dataType: "json",
			cache: false,
			data: data,
			beforeSend: function () {
				form.attr("request", 1);
				if (
					form.css("position") != "absolute" &&
					form.css("position") != "relative"
				)
					form.css("position", "relative");
				$(
					'<div class="loading"><div class="lds-ripple"><div></div><div></div></div></div>'
				).appendTo(form);
			},
			success: function (data) {
				form.attr("request", 0);
				if (data.code == 200) {
					form.addClass("success");
					form.find('button[type="submit"]').prop("disabled", true);
				} else if (typeof data.message != "undefined") {
					alertify.error(data.message);
				}
			},
			error: function (x, e) {
				form.attr("request", 0);
				var e_msg = "";
				if (x.status == 0)
					e_msg = "You are offline!!<br> Please Check Your Network.";
				else if (x.status == 404) e_msg = "Requested URL not found.";
				else if (x.status == 500)
					e_msg = "Internel Server Error." + x.responseText;
				else if (e == "parsererror")
					e_msg = "Error.<br>Parsing JSON Request failed.";
				else if (e == "timeout") e_msg = "Request Time out.";
				else if (e == "error") e_msg = "Request error.";
				else if (e == "abort") e_msg = "Request abort.";
				else e_msg = "Unknow Error.<br>" + x.responseText;
			},
			complete: function () {
				$(".loading").remove();
			},
		});
	}
}
